import React from 'react'

const SlideHeading = ({ heading, className }: { heading: string; className?: string }) => {
  return <div className={`font-semibold text-3xl text-center mb-4 text-primary ${className}`}>{heading}</div>
}

export default SlideHeading
